import styled from 'styled-components'
import { media } from '../../../utils/mediaQuery'

export const ViewToggleContainer = styled.div`
  display: flex;
  background: ${({ theme }) => theme.colors.background.primary};
  border: 1px solid ${({ theme }) => theme.colors.border.default};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  overflow: hidden;
  box-shadow: ${({ theme }) => theme.shadows.md};
`

export const ViewToggleButton = styled.button<{ $active: boolean }>`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: ${(props) =>
    props.$active
      ? props.theme.colors.primary
      : props.theme.colors.background.primary};
  color: ${(props) =>
    props.$active
      ? props.theme.colors.text.inverse
      : props.theme.colors.text.secondary};
  border: none;
  cursor: pointer;
  transition: all ${({ theme }) => theme.transitions.fast};
  font-family: inherit;
  font-size: 11px;
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  min-width: 64px;
  justify-content: center;

  &:hover {
    background: ${(props) =>
      props.$active
        ? props.theme.colors.primaryHover
        : props.theme.colors.background.tertiary};
    color: ${(props) =>
      props.$active
        ? props.theme.colors.text.inverse
        : props.theme.colors.text.primary};
  }

  &:focus {
    outline: none;
    box-shadow: ${({ theme }) => theme.shadows.focus};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  ${media.tabletDown} {
    padding: 6px 10px;
    font-size: 11px;
    min-width: 40px;
    gap: 4px;
  }
`

export const ViewToggleIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 13px;
    height: 13px;
    stroke-width: 2;

    ${media.tabletDown} {
      width: 12px;
      height: 12px;
    }
  }
`

export const ViewToggleLabel = styled.span`
  ${media.mobileOnly} {
    display: none;
  }
`
